import { render, staticRenderFns } from "./Comp12t3.vue?vue&type=template&id=94bf08c0&scoped=true&"
import script from "./Comp12t3.vue?vue&type=script&lang=js&"
export * from "./Comp12t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp12t3.vue?vue&type=style&index=0&id=94bf08c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf08c0",
  null
  
)

export default component.exports